import Transform from '@ember-data/serializer/transform';

// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  serialize(percentage) {
    return percentage?.toString();
  },
  deserialize(percentage) {
    return Number.parseFloat(percentage);
  }
});